import { Component, ViewChild, OnInit } from '@angular/core';
import { PatientSearch } from '../../../model/patient/patient-search';
import { PatientViewComponent } from '../../patient-view/patient-view.component';
import { WizardStep } from '../../../wizard/wizard.component';
import { PatientSearchComponent } from '../../patient-search/patient-search.component';
import { ReservationWizardService } from 'src/app/services/wizard/reservation/reservation.wizard.service';
import { NotificationToastService } from 'src/app/services/notification-toast.service';
import { PatientReservationMessageService } from 'src/app/services/patient-reservation-message.service';

@Component({
  selector: 'app-reservation-patient-required-component',
  templateUrl: './reservation-patient-required.component.html',
  styleUrls: ['./reservation-patient-required.component.css']
})
export class ReservationPatientRequiredComponent implements OnInit, WizardStep {

  isInit: boolean;
  public patientSearched = false;
  patient: PatientSearch;

  @ViewChild('patientRequiredViewComponent', {static: false}) patientRequiredViewComponent: PatientViewComponent;
  @ViewChild('patientRequiredSearch', {static: false}) patientRequiredSearch: PatientSearchComponent;

  constructor(public reservationWizardService: ReservationWizardService,
    private patientReservationMessageService: PatientReservationMessageService,
    private notificationToastService: NotificationToastService) {
    this.patient = this.reservationWizardService.reservation.Patient;
    if (this.patient != null) {
      this.patientSearched = true;
    }
  }

  get completed(): boolean { return this.isValid(); }

  isValid() {
      return this.patient != null;
  }

  get valid(): boolean {
    return this.completed;
  }


  save() {
    // this.reservationWizardService.setPatient(this.patient);
  }

  async activate() {
    this.patient = this.reservationWizardService.reservation.Patient;
    if (this.patient != null) {
      this.patientSearched = true;
    } else {
      this.patientRequiredSearch.setSearch(
        this.reservationWizardService.firstNameSearh,
        this.reservationWizardService.lastNameSearh,
        this.reservationWizardService.documentSearh);
    }
    setTimeout(() => this.patientRequiredSearch.setFocus(), 100);
  }

  async onPatientSelected(patientSearch: PatientSearch) {

    if (! this.patient ||  this.patient.Id !== patientSearch.Id) {
      this.patientReservationMessageService.showReservationAlertIfRequired(patientSearch.Id);
    }

    this.patientSearched = true;
    this.patient = patientSearch;
    this.reservationWizardService.setPatient(this.patient);
  }

  async ngOnInit() {
    this.isInit = true;
    this.activate();
  }
}
